import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

import { createShouldForwardProp } from 'helpers/shouldForwardProp';

// components
import AampeTooltip from '../shared/AampeTooltip/AampeTooltip';

interface LabelChipProps {
    title: string;
    onTagClick?: () => void;
    className?: string;
    isHighlighted?: boolean;
}
const shouldForwardProps = createShouldForwardProp(['isHighlighted']);

const LabelChip: React.FC<React.PropsWithChildren<LabelChipProps>> = ({
    title,
    onTagClick,
    className,
    isHighlighted = false,
}) => {
    return (
        <AampeTooltip title={title} arrow placement="top">
            <ChipContainer className={className} onClick={onTagClick}>
                <ChipText isHighlighted={isHighlighted}>{title}</ChipText>
            </ChipContainer>
        </AampeTooltip>
    );
};

const ChipContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    maxWidth: '200px',
});
const ChipText = styled.div.withConfig({
    shouldForwardProp: shouldForwardProps,
})<{ isHighlighted: boolean }>(() => ({
    color: aampeTheme.colors.textAccessibleWG01,
    fontSize: aampeTheme.size.font.default,
    fontWeight: 400,
    lineHeight: '24px',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: aampeTheme.spacing4(1, 2),
    borderRadius: aampeTheme.borderRadius.default,
    '&:hover': {
        fontWeight: aampeTheme.weights.medium,
        borderRadius: aampeTheme.borderRadius.default,
        outline: `1px solid ${aampeTheme.colors.backgroundWG01}`,
    },
    backgroundColor: aampeTheme.colors.backgroundWG01,
}));

export default LabelChip;
